(() => {
	if(typeof __webpack_require__ !== "undefined") {
						var oriLoadScript = __webpack_require__.e;
						var loaded = {};
						function addWaitForNetwork(fn) {
							var loadScript = fn;
							return function waitForNetwork() {
								var unsubscribe;
								var args = arguments;
								if (loaded[args[0]] || !window || !window.navigator || window.navigator.onLine) return fn.apply(null, args);
								return new Promise((resolve) => {
									window.addEventListener("online", resolve);
									unsubscribe = () => window.removeEventListener("online", resolve);
								})
									.finally(unsubscribe)
									.then(function () {
										return loadScript.apply(null, args);
									});
							};
						};

						function addRetry(fn) {
							var oriLoadScript = fn;
							var retryCount = 0;
							return function execWithRetry() {
								var args = arguments;
								return oriLoadScript.apply(null, args)
									.then((result) => {
										loaded[args[0]] = true;
										return result;
									})
									.catch((e) => {
										retryCount += 1;
										if (retryCount > 2) throw e;
										const wait = new Promise(resolve => setTimeout(resolve, 500));
										return wait.then(() => execWithRetry.apply(null, args));
									});
							};
						};
						oriLoadScript = addWaitForNetwork(oriLoadScript);
						oriLoadScript = addRetry(oriLoadScript);
						__webpack_require__.e = oriLoadScript;
					}
})();